import type { TOC } from '@ember/component/template-only'

interface LegendItems {
  [key: string]: {
    categoryClassName: string
    label: string
  }
}

interface Signature {
  Element: HTMLDivElement
  Args: {
    legendItems: LegendItems
  }
}

export const StudentsResultsLegend: TOC<Signature> = <template>
  <div class="flex gap-6 text-sm" ...attributes>
    {{#each-in @legendItems as |_resultCategory legendItem|}}
      <div>
        <span class="inline-block h-3 w-3 rounded-[50%] {{legendItem.categoryClassName}}"></span>
        <span>{{legendItem.label}}</span>
      </div>
    {{/each-in}}
  </div>
</template>

export default StudentsResultsLegend
